// extracted by mini-css-extract-plugin
var _1 = "ExpandedPostModalMagneticWall-module__comment--L8Xhd";
var _2 = "ExpandedPostModalMagneticWall-module__container--loy3b";
export { _1 as "comment", _2 as "container" }
